/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".live-class-carousel[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.live-class-carousel[_ngcontent-%COMP%]   .anchor[_ngcontent-%COMP%]{scroll-margin-top:4rem}"];
export { styles as styles };
//# sourceMappingURL=live-class-section.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-section/live-class-section.component.scss.shim.ngstyle.js
// module id = 1396
// module chunks = 26 27 28